import { createSelector } from 'reselect';

export const getCompaniesAccesor = state => state.companies.companies;

export const companiesSelector = createSelector(getCompaniesAccesor, companies => companies);
